var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(!_vm.$auth.check())?_c('div',[_c('Login'),_c('Blocks'),_c('Create'),_c('YouTube'),_c('Contact')],1):_vm._e(),_c('Guide')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }